/**
 * Created by torugo on 28/04/2017.
 */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  }            from "@angular/core";
import { CommonModule }        from "@angular/common";
import { ReactiveFormsModule,FormsModule } from "@angular/forms";
import { TextMaskModule } from 'angular2-text-mask';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import {TranslateModule} from '../../../translate-module';
import { ActionModule } from "../actions/action.module";
import { ItemTriggerComponent } from "./itemTriggers";

@NgModule({
    imports : [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      TextMaskModule,
      ActionModule,
      NguiAutoCompleteModule,
      TranslateModule,
    ],
    declarations : [
      ItemTriggerComponent,

    ],
    providers : [
    ],
    exports:[
      ItemTriggerComponent,

    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class TriggerModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/triggers/trigger.module.ts